import { baseQuery } from '../baseQuery';
import type { BillingServiceType } from 'types';

export const getBillingServiceTypes = async () => {
  const { data }: { data: BillingServiceType[] } = await baseQuery('billing-service-types');

  return data;
};
